import { gql } from '@apollo/client'

export const EXPORT_PROCESSING_QUERY = gql`
  query ProcessingActivities(
    $first: Int
    $after: String
    $where: ProcessingActivitiesGraphQlFilterInput
    $order: [ProcessingActivitiesGraphQlSortInput!]
  ) {
    processingActivities(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        activityName
        processFlow
        clickUpId
        additionalSupplementaryInformation
        functionalUnit
        totalIngredientMass
        totalProductAndWasteWeight
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        dataQualityCompletenessScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceCountryISOCode
        referenceRegionIdentifier
        referenceTechnologyType
        referenceTechnologyProxyContribution
        dataQualityComment
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verifiedOn
        lastUpdatedName
        updated
        userEmail
        verificationComments
        verifiedByName
        verifiedByEmail
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
